import memoize from 'lodash/memoize';
import get from 'utils/get';

import sanitizeInternalLink from 'state/sanitizers/sanitizeInternalLink';
import sanitizeModuleOptions from 'state/sanitizers/modules/sanitizeModuleOptions';

import { EmphasisLinkCardModule } from 'types';

export default memoize((module: unknown): EmphasisLinkCardModule => {
  return {
    type: get(module, '_type', 'emphasisLinkCard'),
    id: get(module, '_key', ''),
    content: {
      id: get(module, '_key', ''),
      title: get(module, 'contentTitle', ''),
      description: get(module, 'contentDescription', ''),
      button: {
        label: get(module, 'buttonLabel', ''),
        url: sanitizeInternalLink(get(module, 'buttonUrl', '')),
        variant: get(module, 'buttonVariant', 'underline-black'),
        gtmTrackerEventName: get(module, 'gtmTrackerEventName', ''),
      },
    },
    contentTitleAlignment: get(module, 'contentTitleAlignment', 'left'),
    moduleOptions: sanitizeModuleOptions(module),
  };
});
